<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import {AxiosPost} from "./api/axios";
  import wx from 'weixin-js-sdk'
  import {Toast} from "vant";
  import utils from './api/utils'
  export default {
    name: 'App',
    data() {
      return {}
    },
    methods: {
      getJsapi() {
        let data = {
          url: encodeURIComponent(window.location.href),                //类型：String  必有字段  备注：当前URL .split('?')[0]
          platform: "wap_spread",
        }
        AxiosPost('/member/jsapi/sign', data).then(res => {
          console.log(res);
          if (res.code == 200) {
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.data.appId, // 必填，公众号的唯一标识
              timestamp: res.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
              signature: res.data.signature,// 必填，签名
              //请尽快迁移使用客户端6.7.2及JSSDK 1.4.0以上版本支持的 wx.updateAppMessageShareData、wx.updateTimelineShareData接口
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage','chooseWXPay'] // 必填，需要使用的JS接口列表
            });
          } else {
            Toast(res.message);
          }
        })
      },

      // 推广js
      getTuiJs() {
        AxiosPost("ad/car/common/js", {}).then(response => {
          // 创建script标签，引入外部文件
          let script = document.createElement("script");
          script.type = "text/javascript";
          script.text = response.data.header_js_url_fuc;
          document.getElementsByTagName("head")[0].appendChild(script);
        });
      },

    },
    components: {Toast},
    created() {
      //获取js权限
      if (utils.getIsWxClient()) {  //是否微信浏览器
        this.getJsapi()
      } else {
        console.log('非微信浏览器');
      }
    },
    mounted() {
      this.getTuiJs();
    },
  }
</script>

<style>
  @import "assets/style/beas.css";

  #app {
    font-family: inheirt;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue